import { Loading } from "components/shared";
import { Button } from "components/ui";
import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext, useEffect, useState } from "react";
import useResponsive from "utils/hooks/useResponsive";
import useMagicAction, { RESULT_SCHEMA, ITEMS_SCHEMA, asText, asItems } from "./useMagicAction";


const BrainstormIdeas = (props) => {

    const { selectedText, fullText, selectionStartEnd } = props;
    const { company } = useContext(CompanyContext);
    const { isLoading, run, writeBackInsert, closeMenu } = useMagicAction(props);
    const [ ideas, setIdeas ] = useState([]);
    const { smaller } = useResponsive();
    const mobile = smaller.md;
    const perPage = 15;

    const handleOnClick = async (about) => {
        const given = selectedText?.trim() ? selectedText : fullText?.substring(0, selectionStartEnd.finish);
        run({
            prompt: `Write a social post of about 280 characters about "${about}".${given ? `\n\nDo not repeat this existing text:\n${given}` : ``}`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackInsert(asText(r)))
            .finally(closeMenu);
    }

    const generateIdeas = () => {
        run({
            prompt: fullText?.trim()
                ? `Brainstorm ${perPage} short content ideas (each at most 3 words) based on the following text:\n\nTEXT:\n${selectedText?.trim() ? selectedText : fullText.substring(0, selectionStartEnd.finish)}`
                : `Brainstorm ${perPage} short content ideas (each at most 3 words) for a social post for ${company?.name}.`,
            schema: ITEMS_SCHEMA("A content idea of at most 3 words"),
        }).then((r) => {
            setIdeas((prev) => [...prev, ...asItems(r)]);
        });
    }

    useEffect(() => {
        generateIdeas();
    }, []);

    return (
        <div className={`flex items-center justify-center p-0 gap-2 ${mobile ? `w-full` : `max-w-[350px]`}`}>
            {isLoading
                ? <Loading type={'element'} />
                : <div className={mobile ? `w-full` : ``}>
                    <div className={`overflow-y-auto ${mobile ? `max-h-[45vh]` : `max-h-[350px]`}`}>
                        {ideas?.map((item, key) => (
                            <div
                                key={key}
                                className={`m-1 cursor-pointer inline-block rounded-xl border border-gray-200 dark:border-gray-600 transition-all hover:bg-primary-600/20 hover:border-primary-600 hover:text-primary-600 ${mobile ? `px-3 py-1.5 text-sm` : `px-2.5 py-1 !text-[10px]`}`}
                                onClick={() => handleOnClick(item)}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                    <Button onClick={generateIdeas} variant="twoTone" className="w-full mt-2 text-xs" size="sm">Brainstorm more...</Button>
                </div>
            }
        </div>
    )
}

export default BrainstormIdeas;
